module.exports = __webpack_public_path__ + "static/media/pomme.6cafa8be.svg";